import React from 'react'
import * as S from './styled'
import i18n from 'live/services/i18n'

interface Props {
    message?: string
    size?: number
}

const LoadingSpinner: React.FC<Props> = ({ message, size }) => {
    return (
        <S.LoadingContainer>
            {i18n(message || 'Loading...')}
            <S.Separator />
            <i className="fas fa-spinner fa-pulse fa-2x" />
        </S.LoadingContainer>
    )
}

export default LoadingSpinner
